export default __webpack_public_path__ + "results-placeholder.svg?8ca147c175e0a8b6b537fc0d6be0da9b";